import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-custom" }
const _hoisted_2 = { class: "header__menu" }
const _hoisted_3 = { class: "header__menu-logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/layouts/logo.svg",
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "header__menu-list" }
const _hoisted_7 = { class: "list__item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/layouts/logo.svg",
  alt: ""
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "header__menu-action" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "action__button" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "javascript:;",
    class: "action__button-link"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/assets/images/icons/icon-login.svg",
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "Login")
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "action__icon-line" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

import router from '@/router'
import { useCommonStore } from '@/stores/common/common'
import { computed, onMounted, reactive } from 'vue'
import { scrollToElement } from '@/utils/util'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const common = useCommonStore()
const body = document.querySelector('body')

const isStickyMenu = computed(() => {
  return common.isStickyMenu
})
const isShowMenu = computed(() => {
  return common.isShowMenu
})

const state = reactive({
  listMenu: [
    { title: 'Venture Builder', link: 'venture' },
    { title: 'VB Model', link: 'model' },
    { title: 'We work', link: 'work' },
    { title: 'Contact', link: 'contact' },
  ]
})

function handleToggleMenu (val: boolean) {
  if (!isShowMenu.value && val) {
    body?.classList.add('active')
    common.toggleMenu(true)
  } else {
    body?.classList.remove('active')
    common.toggleMenu(false)
  }
}

const handleClick = (link: string) => {
  router.replace({ name: 'Home', params: { id: link } })
  scrollToElement(link)
  handleToggleMenu(false)
}

onMounted(() => {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
      if (!isStickyMenu.value) common.stickyMenu(true)
    } else {
      if (isStickyMenu.value) common.stickyMenu(false)
    }
  })
  const sections = document.querySelectorAll(".section");
  const links = document.querySelectorAll(".header__menu-list .list__item a");
  window.addEventListener("scroll", () => {
    let current: any
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      if (pageYOffset >= sectionTop - sectionHeight / 8) {
        current = section.getAttribute("id");
      }
    });
    links.forEach((li) => {
      li.classList.remove("active");
      if (li.classList.contains(current)) {
        li.classList.add("active");
      }
    });
  });
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { sticky: _unref(isStickyMenu) }])
  }, [
    _createElementVNode("div", {
      class: "header__overlay",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToggleMenu(false)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: "javascript:;",
            class: "logo__link",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleClick('home')), ["prevent"]))
          }, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: "javascript:;",
              class: "list__item-logo",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleClick('home')), ["prevent"]))
            }, _hoisted_9)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listMenu, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "list__item"
            }, [
              _createElementVNode("a", {
                href: "javascript:;",
                class: _normalizeClass(`list__item-link ${item.link} { active: item.link === router.currentRoute.value.path.split('/')[1] }`),
                onClick: _withModifiers(($event: any) => (handleClick(item.link)), ["prevent"])
              }, _toDisplayString(item.title), 11, _hoisted_10)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", {
            class: "action__icon",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleToggleMenu(true)))
          }, _hoisted_14)
        ])
      ])
    ])
  ], 2))
}
}

})